import {
    CompanyCityContainer,
    CompanyHouseNoContainer,
    CompanyNameContainer,
    CompanyStreetContainer,
    CompanyZipCodeContainer,
} from '../elements/CompanyInfoElementContainers';
import { CountrySelect } from '../elements/CountrySelect';
import { VatField } from '../elements/VatField';
import { VatInfo } from '../elements/VatInfo';
import { EuVatValidator } from '../companyInfo.validators';
import { CompanyInfoNextButton } from '../elements/CompanyInfoNextButton';
import { AlreadyRegistered } from '../elements/AlreadyRegistered';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../configuration/setup/hooks';
import { Region, setRegion, regionSelector } from '../../region/regionSlice';
import { LanguageSelect } from '../elements/LanguageSelect';

export const EuropeCompanyInfo = () => {
    const dispatch = useDispatch();
    const region = useAppSelector(regionSelector);
    useEffect(() => {
        if (region !== Region.europe) {
            dispatch(setRegion(Region.europe));
        }
    }, [dispatch, region]);

    return (
        <form className={'CompanyDataContainer'}>
            <VatInfo />
            <div className={'row'}>
                <div className={'flex-sm'}>
                    <CompanyNameContainer
                        width={'col-sm-6 margin-bottom-5'}
                        error={'intl-msg:registration.error.companyName'}
                        required
                    />
                    <VatField
                        validator={EuVatValidator}
                        vatLabel={'intl-msg:registration.companyData.vatIdNumber'}
                        required
                        showPopoverIcon
                    />
                </div>
                <div className={'flex-sm'}>
                    <CompanyStreetContainer
                        width={'col-sm-8 margin-top-10 margin-bottom-5'}
                        error={'intl-msg:registration.error.street'}
                        required
                    />
                    <CompanyHouseNoContainer
                        width={'col-sm-4 margin-top-10 margin-bottom-5'}
                        error={'intl-msg:registration.error.houseNo'}
                        required
                    />
                </div>
                <div className={'flex-sm'}>
                    <CompanyZipCodeContainer width={'col-sm-6 margin-top-10 margin-bottom-5'} required />
                    <CompanyCityContainer
                        width={'col-sm-6 margin-top-10 margin-bottom-5'}
                        error={'intl-msg:registration.error.city'}
                        required
                    />
                </div>
                <div className={'flex-sm'}>
                    <CountrySelect required />
                </div>
                <div className={'flex-sm'}>
                    <LanguageSelect tenant={'rio-eu.prod'} required />
                </div>
            </div>
            <hr />
            <div className={'margin-top-20-sm'}>
                <div className={'display-flex justify-content-between flex-wrap'}>
                    <AlreadyRegistered />
                    <CompanyInfoNextButton />
                </div>
            </div>
        </form>
    );
};
